import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Badge } from "react-bootstrap";
import HelpButton from "../../HelpContent/HelpButton";
import NewFeature from "../../Builder/Components/NewFeature";

export default function BoomcastWidget() {
  const [customerName, setCustomerName] = useState(
    "Default boomerang client 2024-11-11 18:01:31"
  );
  const [startDate, setStartDate] = useState("2024-11-12");
  const [expiryDate, setExpiryDate] = useState(" 2025-11-10");

  const [status, setStatus] = useState("active");

  return (
    <div className=" h-100 p-3 text-white rounded-3">
      <div className="card-body d-flex flex-column justify-content-between">
        <div className="widget-header ">
          <img
            src="/assets/system/logos/boomcast.png"
            alt=""
            style={{ height: "1rem" }}
          />{" "}
          <HelpButton helpKey="widget-broadcast" iconClassName="white" />
          <Badge bg="secondary" className="ms-5">
            <FontAwesomeIcon icon={faCheckCircle} className="me-1" />
            Full version
          </Badge>
        </div>
        <NewFeature>
          <hr className="text-white my-2" />
          <div className="text-center">
            <h1 className="fw-bold fs-4 m-0">{customerName}</h1>
            <div className="d-flex justify-content-between align-items-end">
              <div>
                <div className="fs-6 fw-bold text-white mt-2">Start date:</div>
                <div className="opacity-50 small">{startDate}</div>
                <div className="fs-6 fw-bold text-white mt-2">End date:</div>
                <div className="opacity-50 small">{expiryDate}</div>
              </div>
              <button
                type="button"
                className={`btn btn-light btn-sm px-3 py-0 rounded-pill text-purple text-xs fw-bold mx-1 ${
                  status === "active" ? "" : "opacity-50"
                }`}
                onClick={() => setStatus("today")}
              >
                ACTIVE
              </button>
            </div>
            <div className="text-center   ">
              <hr className="text-white my-2" />
            </div>
            <Badge bg="secondary" className="mt-2">
              Terms & Conditions unregistered
            </Badge>
          </div>
          <hr className="text-white my-2" />
          <div className="fs-6 fw-bold text-white mt-2">Inbound Campaign</div>
          <div className="opacity-50 small">Expires N/A</div>
          <hr className="text-white my-2" />
          <div className="fs-6 fw-bold text-white mt-2">Incident Hub</div>
          <div className="opacity-50 small">Expires N/A</div>
          <hr className="text-white my-2" />{" "}
          <div className="fs-6 fw-bold text-white mt-2">Triage</div>
          <div className="opacity-50 small">Expires N/A</div>
          <hr className="text-white my-2" />
        </NewFeature>
      </div>
    </div>
  );
}
